/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View, StyleSheet } from 'react-native';
import { CHECK_SIZE } from '@/constants';
import Colors from '@global/colors';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';

const TodoTitle = ({ title, isActive = false }) => {
  return (
    <View testID="todo-title-container" style={styles.todoTitle}>
      <SociollaText type="medium" style={styles.todoTitleText}>
        {title}
      </SociollaText>
      {isActive ? (
        <Image
          style={CHECK_SIZE}
          width={CHECK_SIZE.width}
          height={CHECK_SIZE.height}
          svg={true}
          source={require('@assets/img/icons/check-circle-blue.svg')}
        />
      ) : (
        false
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  // eslint-disable-next-line react-native/no-color-literals
  todoTitle: {
    width: '100%',
    padding: 15,
    backgroundColor: '#f1f1f1',
    borderTopColor: Colors.grey0,
    borderBottomColor: Colors.grey0,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  todoTitleText: { fontSize: 13, color: Colors.grey1 },
});

export default React.memo(TodoTitle, (prev, next) => prev == next);
